





















import { Component, Vue, Prop } from "vue-property-decorator";
import EventBus from "@/utils/event_bus";
@Component({
  components: {}
})
export default class PostGallerySwitch extends Vue {
  @Prop({ default: true })
  private value!: boolean;
  @Prop({ default: "absolute" })
  private position?: string;

  private clickSwitch() {
    EventBus.$emit("postGallerySwitchChange", this.value);
  }
}
